import { FC, useCallback } from 'react';
import { toast } from 'react-toastify';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useConfirm from 'src/hooks/useConfirm';
import useDeleteInvoicesApi from 'src/services/useDeleteInvoicesApi';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from './InvoiceDetailsContext';
import useInvoiceButtonState from './useInvoiceButtonState';

interface DeleteInvoiceProps {}

const DeleteInvoice: FC<DeleteInvoiceProps> = () => {
  const invoiceId = useContextSelector(InvoiceContext, (value) => value.invoiceId);
  const refreshPage = useContextSelector(InvoiceContext, (value) => value.refreshPage);
  const title = useContextSelector(InvoiceContext, (value) => value.title);

  const { deleteInvoices, deletedInvoicesLoading } = useDeleteInvoicesApi();
  const { confirm } = useConfirm();
  const [message, buttonState] = useInvoiceButtonState('Delete');

  const handleDeleteInvoice = useCallback(async () => {
    const invoiceIds: string[] = [invoiceId];
    try {
      const isDeleteApproved = await confirm({
        title: `Delete Document`,
        content: `Are you sure you want to Delete this Document?`,
        confirmButtonText: 'OK',
      });
      if (isDeleteApproved) {
        await deleteInvoices({ invoiceIds });
        refreshPage();
        toast.success(`${title} deleted successfully!`);
      }
    } catch (e) {
      console.error(e);
    }
  }, [invoiceId, confirm, deleteInvoices, refreshPage, title]);

  return (
    <PopUp
      popupAlign={{ horizontal: 'center', vertical: 'top' }}
      content={
        <div className="m-1 max-w-[350px]">
          <PopUpContentWrapper type="Error" contents={[...message]} />
        </div>
      }
      show={isButtonDisabled(buttonState)}
    >
      <Button
        onClick={handleDeleteInvoice}
        color="error"
        buttonState={buttonState}
        disabled={isButtonDisabled(buttonState)}
        loading={deletedInvoicesLoading}
      >
        Delete
      </Button>
    </PopUp>
  );
};

export default DeleteInvoice;
